<script>
    export default {
        name: "TheGuaranteeListItem",
        props: {
            guarantee: Object,
        },
        computed: {
            imageSrc() {
                return `/static/assets/gif/${this.guarantee.image}`;
            },
        },
    };
</script>

<template>
    <div class="guarantee-item">
        <div class="guarantee-item__ico">
            <img :src="imageSrc" :alt="guarantee.title" />
        </div>
        <div class="guarantee-item__title">{{ guarantee.title }}</div>
        <div class="guarantee-item__text" v-html="guarantee.text"></div>
    </div>
</template>

<style lang="scss">
    .guarantee-item {
        @include bp($bp-desktop-sm) {
            text-align: center;
        }
    }

    .guarantee-item__ico {
        position: relative;
        @include box(48px);
        margin: 0 0 16px;
        @include bp($bp-mobile-sm) {
            margin: 0 auto 16px;
        }

        img {
            @include box(100%);
            position: absolute;
            object-fit: cover;
        }
    }

    .guarantee-item__title {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
    }

    .guarantee-item__text {
        font-size: 14px;
        line-height: 22px;
        color: var(--primary-text--light);
    }
</style>
